import Component from '../../shared/component';

export default class LikeButton extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.resourceType = this.$element.data('resource-type');
    this.resourceId = this.$element.data('resource-id');

    this.$likeStats = $(
      `.socialBox-stats-like[data-resource-type=${this.resourceType}][data-resource-id=${this.resourceId}]`
    );
    this.$largeLikeButtonLabel = this.$element.find('.largeLikeButton-label');

    this.$smallLikeButtonConversationPopUp = this.$element
      .parent()
      .find('.contactMentorPopup');

    this.bindEvents();
  }

  bindEvents() {
    this.handleAJAXBefore = this.handleAJAXBefore.bind(this);
    this.handleAJAXSuccess = this.handleAJAXSuccess.bind(this);

    this.$element.on('ajax:before.LikeButton', this.handleAJAXBefore);
    this.$element.on('ajax:success.LikeButton', this.handleAJAXSuccess);
  }

  unbindEvents() {
    this.$element.off('ajax:before.LikeButton', this.handleAJAXBefore);
    this.$element.off('ajax:success.LikeButton', this.handleAJAXSuccess);
  }

  handleAJAXBefore(event) {
    this.httpMethod = $(event.currentTarget).data('method');
  }

  handleAJAXSuccess(_event, data) {
    this.hideOpenedMentorPopups();

    if (this.httpMethod === 'delete') {
      this.$element.removeClass('socialBox-actions-item--enabled');
      this.$element.data('method', 'post');
    }

    if (this.httpMethod === 'post') {
      this.$smallLikeButtonConversationPopUp.show();
      this.$element.addClass('socialBox-actions-item--enabled');
      this.$element.data('method', 'delete');
    }

    if (this.$element.data('reload')) {
      window.Turbolinks.reload({keepScrollPosition: true});
    } else {
      this.refreshLargeLikeButtonLabel(data.buttonLabel);
      this.refreshLikesLabel(data.statsMessage);
    }
  }

  hideOpenedMentorPopups() {
    $('.contactMentorPopup:visible').hide();
  }

  refreshLikesLabel(message) {
    this.$likeStats.html(message);
  }

  refreshLargeLikeButtonLabel(label) {
    if (this.$largeLikeButtonLabel.length) {
      if (this.httpMethod === 'delete') {
        this.$element.removeClass('btn-primary');
        this.$element.addClass('btn-default');
      } else {
        this.$element.removeClass('btn-default');
        this.$element.addClass('btn-primary');
      }

      this.$largeLikeButtonLabel.html(label);
    }
  }
}
